import type { BankMerchantLink } from '../../entities/bank-match/index.js';
import { List, ListItem, Sheet, type SheetAction } from '../../shared/ui/index.js';

type BankMerchantsProps = {
  merchants: BankMerchantLink[];
  chosenMerchant: BankMerchantLink | null;
  isUnlinking: boolean;
  onChoose: (merchant: BankMerchantLink) => void;
  onDismiss: () => void;
  onUnlink: (linkId: string) => void;
};

const unlinkQuestionOf = (merchant: BankMerchantLink | null): string | undefined => {
  if (merchant === null) {
    return undefined;
  }

  return `Відв'язати «${merchant.description}»? Нові списання цього продавця більше не підтверджуватимуть підписку.`;
};

export const BankMerchants = ({
  merchants,
  chosenMerchant,
  isUnlinking,
  onChoose,
  onDismiss,
  onUnlink,
}: BankMerchantsProps) => {
  const unlinkActions: SheetAction[] =
    chosenMerchant === null
      ? []
      : [
          {
            id: 'unlink',
            label: "Відв'язати",
            danger: true,
            disabled: isUnlinking,
            onSelect: () => {
              onDismiss();
              onUnlink(chosenMerchant.id);
            },
          },
        ];

  return (
    <>
      <List
        header="Продавці з банку"
        footer="Списання цих продавців самі підтверджують платежі підписки."
      >
        {merchants.map((merchant) => (
          <ListItem
            key={merchant.id}
            title={merchant.description}
            chevron
            disabled={isUnlinking}
            onClick={() => {
              onChoose(merchant);
            }}
          />
        ))}
      </List>

      <Sheet
        open={chosenMerchant !== null}
        actions={unlinkActions}
        title={unlinkQuestionOf(chosenMerchant)}
        onClose={onDismiss}
      />
    </>
  );
};
